import {React} from "react";
import   "../pages/styles.css";
import  martins from "../images/LeadUs/martin.png";
import  dupre from "../images/LeadUs/dupre.png";
import  dicks from "../images/LeadUs/dick.png";
import  gonzales from "../images/LeadUs/gonzales.png";
import  henrie from "../images/LeadUs/henrie.png";
import  horne from "../images/LeadUs/henrie.png";
import  kroney from "../images/LeadUs/kroney.png";
import  long from "../images/LeadUs/long.png";
import  loewen from "../images/LeadUs/loewen.png";
import  mcgyver from "../images/LeadUs/mcgyver.png";
import  neighbors from "../images/LeadUs/neighbors.png";
import  empty from "../images/LeadUs/empty.png";

// import TextImage from "../Common/TextImage";
import ImageText from "../Common/ImageText"

// KermisClub#!
// emailjsKermisClub#!

const LeadersPage = () => {

     return (
<div style={{background:"#eceff3f6"}}>
      <div className={`boldFancyHeadFontCenter`} >
          <h1 >2025-2026 Kermis Club Executive Board</h1>
          <h2>Our Officers</h2>
          
      </div>
     
      <div style={{display:"flex",alignItems:"center", width:"auto", margin:"auto"}}>
        <ImageText 
          selImage={martins}
          myText="Presidents|Harry Martin and Betty Maines-Martin"
            />
      </div>

      <div style={{display:"flex",alignItems:"center", width:"auto", margin:"auto"}}>
        <ImageText 
          selImage={empty}
          myText="Vice Presidents|Joe and Deonne Sullivan"
            />
      </div>
      <div style={{display:"flex",alignItems:"center", width:"auto", margin:"auto"}}>
        <ImageText 
          selImage={henrie}
          myText="Secretary|Linda Henrie"
            />
      </div>
      <div style={{display:"flex",alignItems:"center", width:"auto", margin:"auto"}}>
        <ImageText 
          selImage={loewen}
          myText="Treasurer|Donald Loewen"
            />
      </div>
      <div style={{display:"flex",alignItems:"center", width:"auto", margin:"auto"}}>
        <ImageText 
          selImage={dupre}
          myText="Directors|Duke and Helen Dupre"
            />
      </div>
      <div style={{display:"flex",alignItems:"center", width:"auto", margin:"auto"}}>
        <ImageText 
          selImage={mcgyver}
          myText="Directors|Mel McGyver and Linda Samuel"
            />
      </div>
      <div style={{display:"flex",alignItems:"center", width:"auto", margin:"auto"}}>
        <ImageText 
          selImage={dicks}
          myText="Honorary Directors|David and Benita Dick"
            />
      </div>

      <div></div>
      <div>
        <h2>Our Committee Chairs</h2>
      </div>
      <div style={{display:"flex",alignItems:"center", width:"auto", margin:"auto"}}>
        <ImageText 
          selImage={horne}
          myText="Band Liason|Gail Horne"
            />
      </div>
      <div style={{display:"flex",alignItems:"center", width:"auto", margin:"auto"}}>
        <ImageText 
          selImage={kroney}
          myText="Invitations|Susan Kroney"
            />
      </div>
      <div style={{display:"flex",alignItems:"center", width:"auto", margin:"auto"}}>
        <ImageText 
          selImage={neighbors}
          myText="Directory and Website|Leslie Neighbors and Simona Bare"
            />
      </div>
      <div style={{display:"flex",alignItems:"center", width:"auto", margin:"auto"}}>
        <ImageText 
          selImage={long}
          myText="Dance Chair|Melissa Long"
            />
      </div>
      <div style={{display:"flex",alignItems:"center", width:"auto", margin:"auto"}}>
        <ImageText 
          selImage={gonzales}
          myText="Dance Chair|Pete and Gillian Gonzales"
            />
      </div>
      <div style={{display:"flex",alignItems:"center", width:"auto", margin:"auto"}}>
        <ImageText 
          selImage={horne}
          myText="Dance Chair|Gail Horne"
            />
      </div>
    </div>
  )
};
   
export default LeadersPage;